import { render } from "./whats-app-create-message.vue?vue&type=template&id=8af4f2e4&scoped=true"
import script from "./whats-app-create-message.vue?vue&type=script&lang=js"
export * from "./whats-app-create-message.vue?vue&type=script&lang=js"

import "./whats-app-create-message.vue?vue&type=style&index=0&id=8af4f2e4&lang=css"
import "./whats-app-create-message.vue?vue&type=style&index=1&id=8af4f2e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af4f2e4"]])

export default __exports__